import React from "react";
import "./Hero.css";

/**
 * Premium Hero Component - High End UI Design
 *
 * Props:
 *  - bgSrc: string -> background image path
 *  - onSchedule: () => void
 *  - onBrowse: () => void
 *  - className: string -> additional CSS classes
 *  - phoneNumber: string -> phone to dial (default: 253-319-2612)
 */
export default function Hero({
  bgSrc = "/herotwo.jpeg",
  onSchedule = () => {},
  onBrowse = () => {},
  className = "",
  phoneNumber = "253-319-2612",
}) {
  // Build a safe tel: URL (strip non-digits, add +1 for US)
  const digits = String(phoneNumber).replace(/\D+/g, "");
  const telHref =
    digits.startsWith("1") && digits.length === 11
      ? `tel:+${digits}`
      : `tel:+1${digits}`;

  return (
    <section
      className={`kf-hero-premium ${className}`}
      style={{ "--hero-bg": `url("${bgSrc}")` }}
      aria-label="Dempsey Mobile Service Hero Section"
    >
      {/* Enhanced Background Layers */}
      <div className="kf-hero-bg-overlay" aria-hidden="true" />
      <div className="kf-hero-glow" aria-hidden="true" />
      <div className="kf-hero-glass-panel" aria-hidden="true" />
      <div className="kf-hero-particle" aria-hidden="true" />

      {/* Main Content Container */}
      <div className="kf-hero-container">
        <div className="kf-hero-content">
          {/* Enhanced Title */}
          <h1 className="kf-hero-title">
            <span className="kf-title-line kf-title-primary">DEMPSEY MOBILE</span>
            <span className="kf-title-line kf-title-accent">SERVICE</span>
          </h1>

          {/* Animated Subtitle */}
          <div className="kf-hero-subtitle">
            <span className="kf-subtitle-text">Professional Mobile Mechanic Solutions</span>
            <div className="kf-subtitle-underline" />
          </div>

          {/* Enhanced Description */}
          <p className="kf-hero-desc">
            Dempsey Mobile Service offers comprehensive mobile mechanic
            solutions, fleet services with discounts and after-hour options, as
            well as a wide range of repair and maintenance tasks for all vehicle
            types.
          </p>

          {/* Enhanced CTA Section */}
          <div className="kf-hero-actions">
            {/* Call Us Now (dialer) */}
            <a
              className="kf-hero-btn kf-hero-btn-secondary"
              href={telHref}
              aria-label={`Call us now at ${phoneNumber}`}
              role="button"
            >
              <span className="kf-btn-icon" aria-hidden="true">
                <svg viewBox="0 0 20 20" fill="currentColor">
                  <path
                    fillRule="evenodd"
                    d="M2 3.5A1.5 1.5 0 013.5 2h1.148a1.5 1.5 0 011.465 1.175l.716 3.223a1.5 1.5 0 01-1.052 1.767l-.933.267c-.41.117-.643.555-.48.95a11.542 11.542 0 006.254 6.254c.395.163.833-.07.95-.48l.267-.933a1.5 1.5 0 011.767-1.052l3.223.716A1.5 1.5 0 0118 15.352V16.5a1.5 1.5 0 01-1.5 1.5H15c-1.149 0-2.263-.15-3.326-.43A13.022 13.022 0 012.43 8.326 13.019 13.019 0 012 5V3.5z"
                    clipRule="evenodd"
                  />
                </svg>
              </span>
              <span className="kf-btn-text">Call Us Now</span>
            </a>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
     
    </section>
  );
}
